import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { Item } from './item.model';
import { API } from './../../shared/constants/api.constants';

@Injectable()
export class ItemService {

    private resourceUrl = API.host + 'InvoicePortal/change-password';

    constructor(private http: Http) { }

    update(userId: number, item: Item): Observable<Item> {
        const copy = this.convert(item);
        return this.http.post(`${this.resourceUrl}/${userId}`, copy).map((res: Response) => {
            if (!res || !res.json()) {
                throw res.json();
            }

            return res.json();
        });
    }

    // update(item: Item): Observable<Item> {
    //     const copy = this.convert(item);
    //     debugger
    //     return this.http.post(`${this.resourceUrl}`, copy).map((res: Response) => {
    //         if (!res || !res.json) {
    //             throw 'Invalid Code';
    //         }

    //         return res.json().data;
    //     });
    // }

    private convert(item: Item): Item {
        const copy: Item = Object.assign({}, item);
        return copy;
    }
}
